var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirquality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_376_33219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D8EAF9",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 33.5C24.6667 33.5 23.9583 33.2083 23.375 32.625C22.7917 32.0417 22.5 31.3333 22.5 30.5H24.5C24.5 30.7833 24.5958 31.0208 24.7875 31.2125C24.9792 31.4042 25.2167 31.5 25.5 31.5C25.7833 31.5 26.0208 31.4042 26.2125 31.2125C26.4042 31.0208 26.5 30.7833 26.5 30.5C26.5 30.2167 26.4042 29.9792 26.2125 29.7875C26.0208 29.5958 25.7833 29.5 25.5 29.5H16V27.5H25.5C26.3333 27.5 27.0417 27.7917 27.625 28.375C28.2083 28.9583 28.5 29.6667 28.5 30.5C28.5 31.3333 28.2083 32.0417 27.625 32.625C27.0417 33.2083 26.3333 33.5 25.5 33.5V33.5M16 23.5V21.5H29.5C29.9333 21.5 30.2917 21.3583 30.575 21.075C30.8583 20.7917 31 20.4333 31 20C31 19.5667 30.8583 19.2083 30.575 18.925C30.2917 18.6417 29.9333 18.5 29.5 18.5C29.0667 18.5 28.7083 18.6417 28.425 18.925C28.1417 19.2083 28 19.5667 28 20H26C26 19.0167 26.3375 18.1875 27.0125 17.5125C27.6875 16.8375 28.5167 16.5 29.5 16.5C30.4833 16.5 31.3125 16.8375 31.9875 17.5125C32.6625 18.1875 33 19.0167 33 20C33 20.9833 32.6625 21.8125 31.9875 22.4875C31.3125 23.1625 30.4833 23.5 29.5 23.5H16V23.5M32.5 31.5V29.5C32.9333 29.5 33.2917 29.3583 33.575 29.075C33.8583 28.7917 34 28.4333 34 28C34 27.5667 33.8583 27.2083 33.575 26.925C33.2917 26.6417 32.9333 26.5 32.5 26.5H16V24.5H32.5C33.4833 24.5 34.3125 24.8375 34.9875 25.5125C35.6625 26.1875 36 27.0167 36 28C36 28.9833 35.6625 29.8125 34.9875 30.4875C34.3125 31.1625 33.4833 31.5 32.5 31.5V31.5",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_376_33219",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_376_33219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_376_33219",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirquality);
export default __webpack_public_path__ + "static/media/air quality.18d27e81d0ca548b750362257499ed71.svg";
export { ForwardRef as ReactComponent };